function saveNumberOfLoadedPlpPage(button){
    if(button.getAttribute('data-load-untill')) return;
    const previousClick = sessionStorage.getItem('loaded_page');
    window.history.scrollRestoration = 'manual'
    if (!previousClick) sessionStorage.setItem('loaded_page',"1");
    else sessionStorage.setItem('loaded_page',((parseInt(previousClick,10) + 1) + ""))
}

function setScrollPosition(product){
    sessionStorage.setItem('keepScroll',document.documentElement.scrollTop + '');
}